export default __webpack_public_path__ + "static/media/artwork-banner-1.1626f82d.jpg";